export default function getImageLink(image: string) {
  const viteCdnHost = import.meta.env.VITE_CDN_HOST as string;
  return viteCdnHost + '/' + image;
}
